// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"223f9614","703":"7f628ffc","787":"42c912f4"}[chunkId] + ".chunk.js";
};